import { API_FREE_MONTHLY_CREDITS } from '../constants';

type FreeCreditsFeature =
  | { enabled?: boolean; variables?: Record<string, unknown> | null }
  | undefined;

/**
 * Default monthly API credit allotment for accounts without a manual `api_credits.monthly_credits`.
 * The `api_free_credits` feature flag's `free_credits` variable overrides API_FREE_MONTHLY_CREDITS.
 */
export function getFreeMonthlyCredits(feature: FreeCreditsFeature): number {
  const freeCredits = Number(feature?.variables?.free_credits);
  if (feature?.enabled && Number.isInteger(freeCredits) && freeCredits >= 0) {
    return freeCredits;
  }
  return API_FREE_MONTHLY_CREDITS;
}
